import { render, staticRenderFns } from "./LectureItem.vue?vue&type=template&id=45793914"
import script from "./LectureItem.vue?vue&type=script&lang=js"
export * from "./LectureItem.vue?vue&type=script&lang=js"
import style0 from "./LectureItem.vue?vue&type=style&index=0&id=45793914&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports